import React             from 'react';
import {
  FormControlLabel,
  Checkbox as MuiCheckbox,
}                        from '@material-ui/core';
import { CheckboxProps } from '@material-ui/core/Checkbox';

export interface ICheckboxProps extends CheckboxProps {
  field  : any;
  label? : string;
}

export const Checkbox = ({
  label,
  field,
  ...props
}: ICheckboxProps): JSX.Element => (
  <FormControlLabel
    value          = {field.value}
    label          = {label}
    labelPlacement = "end"
    control        = {(
      <MuiCheckbox
        checked={field.value}
        {...field}
        {...props}
      />
    )}
  />
);

Checkbox.defaultProps = {
  color         : 'secondary',
  disableRipple : true,
};
